/**
 * Stan połączenia realtime i jego opis dla użytkownika.
 *
 * DLACZEGO tutaj, a nie w komponencie: to jedyna rzecz, która odróżnia „cisza,
 * bo nic się nie dzieje" od „cisza, bo połączenie padło". Poprzednio feed po
 * trzech nieudanych próbach wyłączał się na stałe i pokazywał wyłącznie
 * „Brak połączenia" — bez informacji, czy ktokolwiek jeszcze próbuje. Czysty
 * moduł pozwala to przetestować bez renderowania komponentu.
 */

/**
 * `unconfigured` to jedyny stan trwały (brak adresu bramy w tej instalacji).
 * Każdy inny jest odwracalny i kończy się kolejną próbą połączenia.
 */
export type WsConnectionState =
  | 'connecting'
  | 'connected'
  | 'reconnecting'
  | 'unauthenticated'
  | 'unconfigured';

export interface WsStatusDescription {
  label: string;
  /** Klasa tła kropki statusu. */
  dotClass: string;
  /** Czy pokazać przycisk natychmiastowego ponowienia. */
  canRetry: boolean;
}

export function describeConnection(
  state: WsConnectionState,
  attempt: number,
  retryInSeconds: number | null
): WsStatusDescription {
  switch (state) {
    case 'connected':
      return { label: 'Live', dotClass: 'bg-green-500 animate-pulse', canRetry: false };
    case 'connecting':
      return { label: 'Łączenie…', dotClass: 'bg-amber-500 animate-pulse', canRetry: false };
    case 'reconnecting':
      return {
        label:
          retryInSeconds !== null
            ? `Ponawianie za ${retryInSeconds}s (próba ${attempt})`
            : `Ponawianie… (próba ${attempt})`,
        dotClass: 'bg-amber-500 animate-pulse',
        canRetry: true,
      };
    case 'unauthenticated':
      return { label: 'Oczekiwanie na sesję', dotClass: 'bg-gray-500', canRetry: true };
    case 'unconfigured':
      return { label: 'Kanał realtime nieskonfigurowany', dotClass: 'bg-red-500', canRetry: false };
  }
}
